// A regenerated thumbnail can leave a deleted blob URL in a visitor's history.
// Refresh only failed images, using the public metadata on the activity page.
export function initializeRecentEventImageRecovery(root = document) {
  const attempted = new WeakSet();
  const requests = new Map();
  const selector = 'img[data-recent-event-url]';

  async function recover(image) {
    if (!image.matches?.(selector) || attempted.has(image)) return;
    attempted.add(image);
    try {
      const url = new URL(image.dataset.recentEventUrl, location.origin);
      if (url.origin !== location.origin) return;
      if (!requests.has(url.href)) {
        requests.set(url.href, fetch(url.href, { credentials: 'same-origin' }).then(async response => {
          if (!response.ok) return null;
          const template = root.createElement('template');
          template.innerHTML = await response.text();
          const metadata = template.content.querySelector('script[data-recent-event]');
          return metadata ? JSON.parse(metadata.textContent) : null;
        }));
      }
      const entry = await requests.get(url.href);
      if (!entry || entry.slug !== image.dataset.recentEventSlug || !entry.img) return;
      const source = new URL(entry.img, location.origin);
      if (!['http:', 'https:'].includes(source.protocol) || source.href === image.src) return;
      image.addEventListener('load', () => {
        try {
          const items = JSON.parse(localStorage.getItem('tbRecentlyViewed') || '[]');
          localStorage.setItem('tbRecentlyViewed', JSON.stringify(
            items.map(item => item?.slug === entry.slug ? { ...item, img: entry.img } : item)
          ));
        } catch (_) { /* The image can still recover with storage disabled. */ }
      }, { once: true });
      image.src = source.href;
    } catch (_) { /* Offline/missing events must not interrupt the strip. */ }
  }

  root.addEventListener('error', event => recover(event.target), true);
  const scan = () => root.querySelectorAll(selector).forEach(image => {
    if (image.complete && !image.naturalWidth) recover(image);
  });
  scan();
  root.addEventListener('DOMContentLoaded', scan, { once: true });
  root.addEventListener('turbolinks:load', scan);
  root.addEventListener('turbo:load', scan);
}
